
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M21.992 17.018a3.003 3.003 0 00-2.49-2.937 3 3 0 00-3.326 1.936h-1.179a2 2 0 01-1.998-2.003 3.007 3.007 0 00-.78-2.003 2.993 2.993 0 00-2.217-1.001H7.824A2.998 2.998 0 004.49 9.05 3.001 3.001 0 002 12.011a2.997 2.997 0 005.824 1.001h2.178c.552 0 .999.45.999 1.002a4.001 4.001 0 003.996 4.006h1.18a2.996 2.996 0 005.815-1.002zm-8.993-6.689v-.32a2 2 0 011.998-2.003h1.18A2.996 2.996 0 0022 7.003a2.997 2.997 0 00-5.824-1.001h-1.179a3.999 3.999 0 00-3.936 3.375c.71.164 1.373.49 1.938.951z","opacity":".75"}})])
          )
        }
      }
    